.cardItem {
  position: relative;
  border: 1px solid #add8e6;
  background-color: #ffffff;
  border-radius: 0.75rem;
  width: 25rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.cardItem:hover {
  overflow: visible;
  z-index: 2;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  cursor: pointer;
}

.cardItemComingSoon {
  border: 1px solid #add8e6;
  background-color: #ffffff;
  border-radius: 0.75rem;
  width: 25rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.cardItemComingSoon:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.cardContent {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem 1.25rem 1rem;
  flex: 1;
}

.circle {
  flex-shrink: 0;
  background-color: #2f80ed;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  color: white;
  height: 1.5rem;
  width: 1.5rem;
}

.text {
  flex: 1;
  min-width: 0;
}

.title {
  color: #2f80ed;
  font-weight: 600;
  font-size: 16;
  margin-bottom: 0.35rem;
  line-height: 1;
}

.description {
  color: #404040;
  font-size: 14;
  font-weight: 400;
  line-height: 1;
}

.cardGroup {
  align-self: center;
  width: 52rem;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 0.5rem;
}

.cardGroup1stLine {
  width: 52rem;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  margin-bottom: -1.5rem;
}

.cardGroup2ndLine {
  width: 52rem;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 900px) {
  .cardGroup {
    align-self: center;
    width: 25rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    margin-top: 2rem;
  }

  .cardGroup1stLine {
    width: 52rem;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    margin-bottom: -1.5rem;
  }

  .cardGroup2ndLine {
    width: 52rem;
    font-size: 14px;
    text-align: center;
  }
}

.loadingContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.loadingIcon {
  border: 8px solid #f3f3f3;
  /* Light grey */
  border-top: 8px solid #3498db;
  /* Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.tooltiptext {
  visibility: hidden;
  width: 150px;
  max-width: min(150px, 50vw);
  background-color: rgba(126, 120, 120, 0.95);
  color: #ffffff;
  text-align: center;
  font-size: small;
  padding: 5px 8px;
  border-radius: 6px;
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 0.5rem;
  z-index: 3;
  box-sizing: border-box;
  pointer-events: none;
}

.cardItem:hover .tooltiptext {
  visibility: visible;
}

/*
 * Viewport < 1520px with chat history open: `data-history-panel-open` is set on Chat container
 * (see Chat.tsx). Center the requirements bubble above the card so it stays on-screen.
 */
@media (max-width: 1519px) {
  :global([data-history-panel-open]) .cardItem .tooltiptext {
    right: auto;
    left: 50%;
    top: auto;
    bottom: calc(100% + 0.5rem);
    transform: translateX(-50%);
    margin-right: 0;
    margin-left: 0;
  }
}
